import { render, staticRenderFns } from "./content-script.vue?vue&type=template&id=6065f56e&"
import script from "./content-script.vue?vue&type=script&lang=ts&"
export * from "./content-script.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports